import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'

const RegisterRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />
}

RegisterRoute.propTypes = {
  component: PropTypes.any.isRequired,
}

export default RegisterRoute
